import {useMemo} from "react";

export const VALIDATION_ERRORS = 'validation_errors';

export default function useValidateImportFormTableRow(rowData) {
    const validationErrors = useMemo(() => {
        if (!rowData[VALIDATION_ERRORS]) return [];

        return rowData[VALIDATION_ERRORS]
            .split('|')
            .filter(Boolean)
            .map((error) => {
                const [header, message] = error.split(':');

                return {
                    header,
                    message,
                }
            })
    }, [rowData]);

    return {
        validationErrors
    }
}
